export enum ValidationWarningType {
  LOW_RESOLUTION = 'LOW_RESOLUTION',
  HIGH_ISO = 'HIGH_ISO',
  SLOW_SHUTTER = 'SLOW_SHUTTER',
  MIXED_CAMERAS = 'MIXED_CAMERAS',
  MIXED_DIMENSIONS = 'MIXED_DIMENSIONS',
  INCONSISTENT_FOCAL_LENGTH = 'INCONSISTENT_FOCAL_LENGTH',
  TOO_FEW_PHOTOS = 'TOO_FEW_PHOTOS',
  INSUFFICIENT_ANGULAR_COVERAGE = 'INSUFFICIENT_ANGULAR_COVERAGE',
  INSUFFICIENT_ALTITUDE_LAYERS = 'INSUFFICIENT_ALTITUDE_LAYERS',
  INCOMPLETE_ORBIT = 'INCOMPLETE_ORBIT',
  LARGE_CAPTURE_TIME_SPAN = 'LARGE_CAPTURE_TIME_SPAN',
  EXPOSURE_BIAS = 'EXPOSURE_BIAS',
}

export interface ValidationWarning {
  type: ValidationWarningType;
  severity: 'warning' | 'info';
  message: string;
  affectedFiles?: string[];
}

export interface ValidationResult {
  noCoords: string[];
  wrongCoords: string[];
  warnings: ValidationWarning[];
}
